import { useEffect, useRef } from 'react'

export interface UseIntersectionObserverOptions {
  threshold?: number
  root?: Element | null
  rootMargin?: string
  enabled?: boolean
}

export function useIntersectionObserver(
  onIntersect: () => void,
  options: UseIntersectionObserverOptions = {},
) {
  const {
    threshold = 0.1,
    root = null,
    rootMargin = '0px',
    enabled = true,
  } = options

  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!enabled || !targetRef.current) {
      return
    }

    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries
        if (entry.isIntersecting) {
          onIntersect()
        }
      },
      {
        threshold,
        root,
        rootMargin,
      },
    )

    observer.observe(targetRef.current)

    return () => {
      observer.disconnect()
    }
  }, [enabled, onIntersect, threshold, root, rootMargin])

  return targetRef
}
